import styles from './OutputReportCard.module.scss';
import BaseProjectCard from '../BaseProjectCard/BaseProjectCard';
import IReport from '../../../types/IReport';
import useDate from '../../../hooks/useDate';

type OutputReportCardProps = {
    report: IReport;
    onClick?: (report: IReport) => void;
};

export default function OutputReportCard(props: OutputReportCardProps) {
    const { report, onClick } = props;
    const { title, type, subtype, internalName, date } = report;
    const formattedDate = useDate(date);

    return (
        <BaseProjectCard
            name={title}
            iconName={internalName}
            type={type}
            subtype={subtype ?? 0}
            onClick={handleReport}
        >
            {!!date && <div className={styles.date}>{formattedDate}</div>}
        </BaseProjectCard>
    );

    function handleReport() {
        onClick?.(report);
    }
}
